import { DealerAction, FlagStateType, SupervisorAction, WorkerAccessLevel } from './app-enums.model';
import { ChatMessageEvent } from './app-events.model';
import { Json } from '../types.model';
import { Game } from './app-state.model';
import { CardsChanged } from './result-change.model';

export enum DealerRequestType {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    DealerAction = 'dealer-action',
    // eslint-disable-next-line @typescript-eslint/no-shadow
    SupervisorAction = 'supervisor-action',
    GetChatMessages = 'get-chat-messages',
    SetFlagState = 'set-flag-state',
    GetAvailableGames = 'get-available-games',
    ChangeGame = 'change-game',
    ChangeGameResult = 'change-game-result',
    CancelSupervisorAction = 'cancel-supervisor-action',
    GetTableHistory = 'get-table-history',
    RegisterWorker = 'register-worker',
    GetTableGroups = 'get-table-groups',
    GetMockWorker = 'get-mock-worker',

    GetRouletteSpeed = 'roulette-speed'
}

export interface SupervisorActionRequestMessage extends Json {
    action: SupervisorAction;
}

export interface DealerActionRequestMessage extends Json {
    action: DealerAction;
}

export interface SetFlagStateRequestMessage extends Json {
    flag: FlagStateType;
    state: boolean;
}

export interface GetChatMessagesResponseMessage extends Json {
    messages: ChatMessageEvent[];
}

export type ChangeGameRequestMessage = Json & {
    gameId?: number;
    continueUnfinishedGameId?: number;
};

export interface ChangeGameResponseMessage extends Json {
    selectedGame: Game;
}

export type GetGamesResponseMessage = Json & {
    games: Game[];
    unfinishedGame?: Game;
};
export interface ResultChangeRequestMessage extends Json {
    cards: CardsChanged;
}

export interface ConfirmResultRequestMessage extends Json {
    data: boolean;
}

export type GetHistoryRequestMessage = Json & {
    max?: number;
};

export type GetRouletteSpeedRequestMessage = Json;

export type GetTableGroupsResponseMessage = Json & {
    tableGroups: string[];
};
export interface RegisterWorkerRequestMessage extends Json {
    id: string;
    name: string;
    tableGroups: string[];
    accessLevel: WorkerAccessLevel;
}
export type RegisterWorkerResponseMessage = Json & {
    success: true;
    error?: string;
};
// For testing purposes until we don't have complete flow
// This simulate worker RFID presented
// As response you will get event EventType:UserR - as planned
export type GetMockWorkerRequestMessage = Json & {
    id?: string; // "scanned" id
    exist?: boolean; // If user exist you will get also worker data
};
